import type { ParsedTable } from '../types'
import { toNumber } from '../generators/helpers'

/**
 * Validates if the parsed table data is suitable for rendering a Scatter chart
 *
 * Note: Our scatter chart implementation plots series across columns,
 * so we just need to ensure there are numeric data points available
 *
 * Checks:
 * - At least one row exists
 * - At least two columns exist (row label + data)
 * - At least one numeric data point exists
 *
 * @param t - The parsed table data
 * @returns True if the data can be rendered as a scatter chart, false otherwise
 */
export function canRenderScatter(t: ParsedTable): boolean {
  if (t.rowCnt === 0 || t.colCnt < 2) {
    return false
  }

  // Check if there is at least one valid numeric data point
  for (let r = 0; r < t.rowCnt; r++) {
    for (let c = 1; c < t.colCnt; c++) {
      if (t.rows[r] && c < t.rows[r].length) {
        const num = toNumber(t.rows[r][c])
        if (num !== null && !isNaN(num)) {
          return true
        }
      }
    }
  }

  console.warn('canRenderScatter: No valid numeric data points found.')
  return false
}
